/* eslint-disable no-unused-vars */
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Dropmenu, Search } from '../../Components';
import { Link, useNavigate } from 'react-router-dom';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { API_URL } from '../../Config/index';
import API from '../../Web/Instance';
import Loading from '../../Components/Loading';
import { getAuthToken } from '../../Redux/Service/FetchBaseQuery';
import { useDispatch } from 'react-redux';
import PostAddIcon from '@mui/icons-material/PostAdd';
import axios from 'axios';
import StyledDashboardLayout from '../style';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useModuleHasPermissions } from '../../hooks/useModulePermissions';

function ProposalList() {
   const MySwal = withReactContent(Swal);
   const [loading, setLoading] = useState(true);
   const navigate = useNavigate();
   const [searchQuery, setSearchQuery] = useState('');
   const [page, setPage] = useState(1);
   const [data, setData] = useState([]);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [AccessToken, setAccessToken] = useState(null);
   const [error, setError] = useState(null);
   const hasPermissions = useModuleHasPermissions('proposal');

   const dispatch = useDispatch();
   const fetchData = () => {
      setAccessToken(getAuthToken());

      API.get(
         `${API_URL}proposal/list?limit=${rowsPerPage}&page=${page - 1}&orderBy=DESC&search=${searchQuery}`,
         {
            headers: {
               Authorization: `Bearer ${getAuthToken()}`,
            },
         },
      )
         .then((response) => {
            if (response.data.statusCode === 200) {
               setData(response.data.response.data);
               setLoading(false);
            }
         })
         .catch((err) => {
            setError(err);
         })
         .finally(() => {
            setLoading(false);
         });
   };
   React.useEffect(fetchData, [searchQuery, page, rowsPerPage]);

   const customStyles = {
      rows: {
         style: {
            margin: '0px',
            padding: 0,
         },
      },
      headCells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontWeight: 600,
            fontSize: 16,
            background: '#3F30FF1A',
         },
      },
      cells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontSize: 15,
            fontWeight: 400,
            color: '#726E6E',
         },
      },
   };

   const handleEdit = (id) => {
      navigate(`/proposal-edit/${id}`);
   };

   const handleSearch = (search) => {
      setSearchQuery(search);
      setPage(1);
   };

   const handleDelete = async (id) => {
      const result = await MySwal.fire({
         title: 'Are you sure?',
         text: 'Are you sure you want to delete this Proposal?',
         icon: 'warning',
         showCancelButton: true,
         confirmButtonText: 'Yes, delete it!',
         cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
         const response = await axios.post(
            `${API_URL}proposal/delete/${id}`,
            {},
            {
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${getAuthToken()}`,
               },
            },
         );

         const resData = response.data;
         if (resData && resData.statusCode === 200) {
            await MySwal.fire('Deleted!', 'Proposal has been deleted.', 'success');
            fetchData();
         } else {
            await MySwal.fire(
               'Cannot delete',
               resData && resData.message ? resData.message : 'Failed to delete Proposal.',
               'error',
            );
         }
      } catch (error) {
         const errMsg =
            error?.response?.data?.message || error.message || 'Failed to delete Proposal.';
         await MySwal.fire('Error!', errMsg, 'error');
         console.error('Error deleting proposal:', error);
      }
   };

   const columns = [
      {
         name: 'SL No',
         cell: (row, index) => index + 1,
         button: false,
      },
      {
         name: 'Proposal Name',
         selector: (row) => row.title,
         sortable: true,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.title}</div>
         ),
      },
      {
         name: 'Opportunity Name',
         selector: (row) => row?.opportunity?.name,
         sortable: true,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
               {row?.opportunity?.name}
            </div>
         ),
      },
      {
         name: 'Created At',
         selector: (row) => new Date(row.createdAt).toLocaleString(),
         sortable: true,
      },
      {
         name: 'Download PDF',
         cell: (row) => (
            <div>
               <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${API_URL}${row.pdfPath}`}
                  className="dark-link"
               >
                  <CloudDownloadIcon /> &nbsp; Download
               </a>
            </div>
         ),
         sortable: true,
      },
      {
         name: 'Action',
         cell: (row) => (
            <div>
               <Dropmenu
                  className="dark-link"
                  handleEdit={() => handleEdit(row.id)}
                  handleDelete={() => handleDelete(row.id)}
                  canEdit={hasPermissions?.canUpdate}
                  canDelete={hasPermissions?.canDelete}
               />
            </div>
         ),
         button: false,
      },
   ];

   if (loading) {
      return <Loading />;
   }

   if (error) {
      return <>Access Denied!</>;
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">Proposals</h1>
                     </div>
                     {hasPermissions?.canAdd && (
                        <div className="btnWrap">
                           <Link to="/proposal-add" className="btn addBtn">
                              <PostAddIcon /> Create Proposal
                           </Link>
                        </div>
                     )}
                  </div>
               </div>
            </div>
            <div className="card m-3 customCard">
               <div>
                  <Grid container spacing={2}>
                     <Grid item md={6} xs={12}></Grid>
                     <Grid item md={6} xs={12} display="flex" justifyContent="flex-end">
                        <Search onSearch={(query) => handleSearch(query)} />
                     </Grid>
                  </Grid>
                  <DataTable
                     columns={columns}
                     data={data}
                     pagination
                     paginationServer
                     // paginationTotalRows={contract.response.pagination.total}
                     paginationDefaultPage={page}
                     paginationPerPage={rowsPerPage}
                     onChangePage={setPage}
                     onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setPage(1);
                     }}
                     customStyles={customStyles}
                     className="dataTable"
                  />
               </div>
            </div>
         </div>
      </StyledDashboardLayout>
   );
}

export default ProposalList;
